import { render, staticRenderFns } from "./CaoZuoShouCe.vue?vue&type=template&id=2c052eb9&scoped=true"
import script from "./CaoZuoShouCe.vue?vue&type=script&lang=js"
export * from "./CaoZuoShouCe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c052eb9",
  null
  
)

export default component.exports